import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 大きなアイコン下部の説明文表示エリア
 */
const DescriptionArea: React.FC<DescriptionAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.description && (
        <StyledDescriptionArea>
          <Text color={props.color}>{props.description}</Text>
        </StyledDescriptionArea>
      )}
    </React.Fragment>
  )
}

export type DescriptionAreaProps = {
  description?: string
  color?: string
}

const StyledDescriptionArea = styled.div`
  margin: 32px;
`

export default DescriptionArea
